import {Form, message} from 'antd';
import axios from 'axios';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {useHistory, useRouteMatch} from 'react-router';
import ActionBar from '../../../../components/action-bar';
import ActionButton from '../../../../components/action-button';
import useDispatchWithResult from '../../../../hooks/useDispatchWithResult';
import useLoading from '../../../../hooks/useLoading';
import {cbeSelector, fetchCBE, fetchCBEs} from '../../../../store/empresa';
import {valuesToFormData} from '../../../../util/formData';
import unwrapAxiosPromise from '../../../../util/unwrapAxiosPromise';
import EmpresaCBEForm from './_form';
import useModulo from "../../../../hooks/useModulo";

export default function EmpresaCBEEditPage() {
  const {t} = useTranslation();
  const dispatch = useDispatchWithResult();
  const [form] = Form.useForm();
  const cbe = useSelector(cbeSelector);
  const loading = useLoading(fetchCBE.typePrefix);
  const [loadingSave, setLoadingSave] = useState(false);
  const history = useHistory();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const id = match.params.id;
  const {moduloBasePath} = useModulo();

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(cbe);
    setImmediate(() => document.querySelector('#dataApresentacao').focus());
  }, [cbe]);

  const handleFinish = values => {
    setLoadingSave(true);
    const formData = valuesToFormData(values);
    unwrapAxiosPromise(axios.put(`/empresas/${empresaId}/cbes/${id}`, formData), form)
        .then(() => {
          message.success(t('Registro alterado com sucesso'));
          history.replace(`${moduloBasePath}/empresas/${empresaId}/cbes/${id}`);
          dispatch(fetchCBEs({empresaId}));
          dispatch(fetchCBE({empresaId, id}));
        })
        .finally(() => setLoadingSave(false));
  };

  const handleCancel = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/cbes/${id}`);
  };

  const title = (
      <ActionBar>
        <ActionButton.Save onClick={form.submit} loading={loadingSave} />
        <ActionButton.Cancel onClick={handleCancel} disabled={loadingSave} />
      </ActionBar>);

  return (
      <EmpresaCBEForm
          disabled={loadingSave}
          form={form}
          loading={loading}
          onFinish={handleFinish}
          title={title}
      />);
}
